import script from "./withdrawalRules.vue?vue&type=script&setup=true&lang=js"
export * from "./withdrawalRules.vue?vue&type=script&setup=true&lang=js"

import "./withdrawalRules.vue?vue&type=style&index=0&id=45145d96&lang=less&scoped=true"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45145d96"]])

export default __exports__